<template>
	<vs-table :max-items="10" pagination :data="listAnswer">
		<template slot="thead">
			<vs-th class="w-1/4">
				{{ $t('siteAutoEmailName') }}
			</vs-th>
			<vs-th class="w-2/4">
				{{ $t('siteAutoEmailTemplate') }}
			</vs-th>
			<vs-th class="w-1/4">
				{{ $t('actions') }}
			</vs-th>
		</template>

		<template slot-scope="{data}">
			<vs-tr :key="indextr" v-for="(tr, indextr) in data">
				<vs-td :data="data[indextr].templateName">
					{{ data[indextr].templateName }}
				</vs-td>
				<vs-td :data="data[indextr].templateTemplate">
                    <div v-html="short(data[indextr].templateTemplate, 150)">
                    </div>
				</vs-td>
				<vs-td :data="data[indextr].templateId">
                    <div class="flex justify-center">
                        <vs-button
                            size="small"
                            color="#626262"
                            type="flat"
                            icon-pack="feather"
							@click="websiteAnswer=currentWebsiteAnswer(data[indextr].templateId); editAnswerActive = true"
                            icon="edit"
                        >
                            <feather-icon icon="EditIcon"></feather-icon>
                        </vs-button>
                    </div>
                </vs-td>        
			</vs-tr>
            <EditSiteAutoEmailAnswer
                :active.sync="editAnswerActive"
                :websiteAnswer="websiteAnswer"
                @confirm="setSiteAutoEmailAnswer"
            />
		</template>
	</vs-table>
    
</template>

<script>
    import databaseManager from "@/mixins/databaseManager";
    import notifier from "@/mixins/notifier";
    import EditSiteAutoEmailAnswer from "@/components/dialogs/EditSiteAutoEmailAnswer";

    export default {
        name: "SiteAutoEmailAnswer",
        mixins: [databaseManager, notifier],
        props: {
            model: { required: true },
        },
        components: {
            EditSiteAutoEmailAnswer,
        },
        data() {
            return {
                listAnswer: {},
                editAnswerActive: false,
                websiteAnswer: null,
            };
        },
        methods: {
            short(str, maxlen) {
                str = str.replace(/(<([^>]+)>)/gi, '');
                if(str.length <= maxlen) {
                    return str;
                } else {
                    return str.slice(0, maxlen) + ' ...'
                }
            },
            // short: (str, maxlen) => str.length <= maxlen ? str : str.slice(0, maxlen) + ' ...',
            async loadAnswerTempate() {
                try {
                    this.listAnswer = await this.dbWebsiteGetAutoEmailAnswer(this.model.id);
                } catch(e) {
                    this.notifyError(e.message);
                }
            },
            openItemEditAnswer() {
                this.editAnswerActive = true;
            },
            currentWebsiteAnswer(id) {
                const current = this.listAnswer.find(item => item.templateId === id);
                return current !== -1 ? current : null;
            },
            async setSiteAutoEmailAnswer(emailTemplateAnswer) {
                try{
                    await this.dbWebsiteSetAutoEmailAnswer(emailTemplateAnswer.templateId, emailTemplateAnswer);
                    this.notifySuccess(`${this.$t('siteAutoEmailTemplateSuccess')}`);
                    this.$emit("updateSite");
                }catch (e) {
                    this.notifyError(e.message);
                }
            },
        },
        async mounted() {
            try {
                this.loadAnswerTempate();
            } catch(e) {
                this.notifyError(e.message);
            }
        }
    };
</script>

<style lang="scss" scoped>

</style>